import { BACKEND_URL } from "@/lib/constants/constants";

import axios from "../custom/axiosConfig";

export const retryExport = async (id: string, exportType: string) => {
  const response = await axios({
    method: "post",
    url: `${BACKEND_URL}/datev/exports/buchungsdatenservice/${exportType}/${id}/retry`,
  });

  return response.data;
};
